module.exports = __webpack_public_path__ + "img/dimension-tooltip.28fee8a6.png";